export const NAV = {
    logo: "nav-logo",
    work: "nav-work",
    topics: "nav-topics",
    about: "nav-about",
    contact: "nav-contact",
    subscribe: "nav-subscribe",
};

export const HERO = {
    title: "hero-title",
    subtitle: "hero-subtitle",
    name: "hero-name",
    role: "hero-role",
    canvas: "hero-canvas",
};

export const WORK = {
    section: "work-section",
    item: (i) => `work-item-${i}`,
};

export const SUBSCRIBE = {
    section: "subscribe-section",
    input: "subscribe-input",
    submit: "subscribe-submit",
};

export const HEART = {
    button: "heart-counter",
    count: "heart-count",
};

export const FOOTER = {
    root: "site-footer",
};

export const HOME = {
    root: "home-root",
};
